import { useTranslation } from 'react-i18next';

import * as IngredientState from 'components/desktop/Ingredient/IngredientState';
import IngredientLanguageInput from 'components/desktop/Ingredient/LanguageInput/IngredientLanguageInput';
import { IngredientDetailHandlers as Handlers } from 'components/desktop/Ingredient/useIngredientState';
import LanguageSwitch from 'components/desktop/_general/LanguageSwitch/LanguageSwitch';
import SynonymsComponent from 'components/desktop/_general/Synonyms/Synonyms';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';
import useCultureCode from 'hooks/redux/useCultureCode';

export const IngredientNameInputs = ({
	state,
	handlers,
}: {
	state: IngredientState.Type;
	handlers: Handlers;
}): JSX.Element => {
	const cultureCode: string = useCultureCode();
	const { t } = useTranslation();

	const isIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEINGREDIENT,
	]);

	return (
		<>
			<LanguageSwitch
				handleSelectLanguage={(_e: any, selectedLanguage: string) => {
					handlers.setSelectedCultureCode(selectedLanguage);
				}}
				selectedLanguage={state.selectedCultureCode}
				translatable={true}
				onTranslateClick={() => handlers.translateAndSetNames(cultureCode)}
				entryLanguage={cultureCode}
				content={
					<div>
						<div className="d-flex flex-column">
							<b className="mt-3">{t('_general:SINGULAR')}</b>
							<label>{t('_general:NAME')}</label>
							<IngredientLanguageInput
								onTranslateClick={() =>
									handlers.translateAndSetName({
										fromCultureCode: cultureCode,
										text: state.nameSingular[cultureCode],
										key: 'nameSingular',
									})
								}
								value={state.nameSingular[state.selectedCultureCode] ?? ''}
								selectedLanguage={state.selectedCultureCode}
								handleValueChange={handlers.setNameSingular}
							/>
							<b className="mt-3">{t('_general:PLURAL')}</b>
							<label>{t('_general:NAME')}</label>
							<IngredientLanguageInput
								onTranslateClick={() =>
									handlers.translateAndSetName({
										fromCultureCode: cultureCode,
										text: state.namePlural[cultureCode],
										key: 'namePlural',
									})
								}
								value={state.namePlural[state.selectedCultureCode] ?? ''}
								selectedLanguage={state.selectedCultureCode}
								handleValueChange={handlers.setNamePlural}
							/>
						</div>
						<SynonymsComponent
							input={state}
							setInput={(input: IngredientState.Type) => {
								handlers.setSynonyms(input.synonyms);
							}}
							cultureCode={state.selectedCultureCode}
							disabled={!isIngredientEditor}
						/>
					</div>
				}
			/>
		</>
	);
};
